export const container = () => ({
    '& .ant-btn.ant-btn-loading': {
        ':hover': {
            cursor: 'pointer',
        },
    },
});
